import { z } from 'zod';
import { msObject } from '../resource-base/msObject';
import { PersistableOutlineBaseSchema } from './basicOutline';

export const SystemAnnouncementOutlineSchema = PersistableOutlineBaseSchema.extend({
    title: z.string(),
    dismissed: z.boolean(),
});

export const StructuredSystemAnnouncementsOutlineSchema = msObject({
    expired: SystemAnnouncementOutlineSchema.array(),
    active: SystemAnnouncementOutlineSchema.array(),
    upcoming: SystemAnnouncementOutlineSchema.array(),
});

export type SystemAnnouncementOutline = z.infer<typeof SystemAnnouncementOutlineSchema>;
export type StructuredSystemAnnouncementsOutline = z.infer<typeof StructuredSystemAnnouncementsOutlineSchema>;
